import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { dateToString } from '../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';
import { BidStatus, BidStatusName } from '../../constants/BidStatus';
import { pencesToPounds } from '../../common/helpers/pencesToPounds';
import { getPriceColor } from '../../helpers/auctionColorHelper';
import ContactTooltip from '../../common/components/ContactTooltip';

const BidsTableRow = ({ item }) => {
  const { firstName, lastName } = item?.bidder;
  const { vehicleMakeName, vehicleModelName } = item;
  const bidderFullName = item ? `${firstName} ${lastName}` : '-';
  const carFullName = item ? `${vehicleMakeName} ${vehicleModelName}` : '-';

  return (
    <>
      <td>{item.serial}</td>
      <td>{item?.vehicleRegistrationPlate}</td>
      <td>{carFullName}</td>
      <td>{dateToString(item?.auctionLaunchedOn)}</td>
      <td>{dateToString(item?.createdOn)}</td>
      <td>
        {item?.autoAcceptPriceInPence
          ? preparePriceFormat(pencesToPounds(item?.autoAcceptPriceInPence))
          : '-'}
      </td>
      <td>
        {item?.highestBidInPence
          ? preparePriceFormat(pencesToPounds(item.highestBidInPence))
          : '-'}
      </td>
      <td style={getPriceColor(item?.shouldBidAmountBeGreen)}>
        {item?.highestProxyBidInPence
          ? preparePriceFormat(pencesToPounds(item.highestProxyBidInPence))
          : '-'}
      </td>
      <td style={getPriceColor(item?.shouldBidAmountBeGreen)}>
        <CurrencyFormat
          value={item?.amountInPence / 100}
          thousandSeparator={true}
          allowNegative={false}
          prefix="£"
          displayType="text"
        />
      </td>
      <td>
        <ContactTooltip
          id={`seller-tooltip${item.id}`}
          label={item?.seller?.organization?.tradeName}
          firstName={item?.seller?.firstName}
          lastName={item?.seller?.lastName}
          phoneNumber={item?.seller?.phoneNumber}
          landlinePhoneNumber={item?.seller?.landingPhoneNumber}
        />
      </td>
      <td>
        <ContactTooltip
          id={`bidder-tooltip${item.id}`}
          label={item?.bidder?.organization?.tradeName}
          firstName={firstName}
          lastName={lastName}
          phoneNumber={item?.bidder?.phoneNumber}
          landlinePhoneNumber={item?.bidder?.landingPhoneNumber}
        />
      </td>
      <td>{bidderFullName}</td>
      <td>
        {item?.status === BidStatus.REJECTED
          ? BidStatusName.OFFER_DECLINED.toUpperCase()
          : item?.status}
      </td>
      <td className="text-right">
        <Button
          className="btn-link"
          color="primary"
          id={`tooltip${item.id}`}
          size="sm"
          type="button"
        >
          <i className="fa fa-info-circle" id={`tooltipIcon${item.id}`} />
        </Button>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`tooltip${item.id}`}
        >
          more details
        </UncontrolledTooltip>
      </td>
    </>
  );
};

export default BidsTableRow;
